import { render, staticRenderFns } from "./AlarmNotificationsHeaderMenu.vue?vue&type=template&id=183d86da&scoped=true"
import script from "./AlarmNotificationsHeaderMenu.vue?vue&type=script&lang=ts"
export * from "./AlarmNotificationsHeaderMenu.vue?vue&type=script&lang=ts"
import style0 from "./AlarmNotificationsHeaderMenu.vue?vue&type=style&index=0&id=183d86da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183d86da",
  null
  
)

export default component.exports